const DEFAULT_WIDTH = 400
const DEFAULT_HEIGHT = 1000

const allowedOrigins = (origin, allowedOrigins) => {
  if (allowedOrigins) {
    return allowedOrigins.includes(origin)
  }
  return false
}
const calculateTop = (windowHeight, topOffset, botHeight) => {
  const top = windowHeight * (topOffset / 100 )
  return top > windowHeight - botHeight ? windowHeight - botHeight : top
}
const calculateLeft = (windowWidth, leftOffset, botWidth) => {
  const left = windowWidth * (leftOffset / 100 )
  return left > windowWidth - botWidth ? windowWidth - botWidth : left
}
const calculateWindowPosition = (windowWidth, windowHeight, topOffset = 0, leftOffset = 100) => {
  const left = calculateLeft(window.outerWidth, leftOffset, windowWidth || DEFAULT_WIDTH)
  const top = calculateTop(window.outerHeight, topOffset, windowHeight || DEFAULT_HEIGHT)
  return { left, top }
}

export const openExternalWindow = config => {
  if (!config.baseUrl) {
    throw new Error('config.baseUrl is required for windowed mode')
  }
  const { external: { windowWidth, windowHeight, topOffset, leftOffset } } = config
  const { left, top } = calculateWindowPosition(windowWidth, windowHeight, topOffset, leftOffset)
  const windowFeatures = `width=${windowWidth || DEFAULT_WIDTH},height=${windowHeight || DEFAULT_HEIGHT}, left=${left}, popup, top=${top},`

  const externalWindow = window.open(
    '', 'dbBotExternalWindow', windowFeatures
  )
  window.addEventListener('message', (event) => {
    if (event.data.type === 'devicebits:stopCall' && allowedOrigins(event.origin, config.external.allowedOrigins)) {
      externalWindow.close()
    }
  })
  externalWindow.focus()

  const configString = encodeURIComponent(JSON.stringify({
    ...config,
    windowed: false,
    embedded: true
  }))
  externalWindow.location.href = `${config.baseUrl}/windowed.html`
        + `?config=${configString}`
}



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Widget/externalWindow.js